import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { HistoryContext } from '../HistoryContext'

export function HistoryProvider({ children }) {
  const [history, setHistory] = useState(['/']) // Initialize with current path
  const navigate = useNavigate()

  useEffect(() => {
    setHistory((prev) => [...prev, window.location.pathname])
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [window.location.pathname])

  const canGoBack = () => history.length > 1

  const getPreviousPage = () => {
    if (history.length >= 2) {
      return history[history.length - 2]
    }
    return '/'
  }

  const goBackOrHome = (navigateTo) => {
    if (navigateTo) {
      navigate(navigateTo)
      return
    }

    if (canGoBack()) {
      navigate(-1)
      return
    }

    navigate('/', { replace: true })
  }

  return (
    <HistoryContext.Provider value={{ goBackOrHome, canGoBack, getPreviousPage, history }}>
      {children}
    </HistoryContext.Provider>
  )
}
